<iframe [src]="attachment() | safe"></iframe>
